/* eslint-disable no-console */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { object } from 'prop-types'
import { FluxosPagamentoProvider } from '../../../../contexts/FluxosPagamentoContext'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useSegundaAssinatura } from '../../../../contexts/SegundaAssinaturaContext'
import FluxosPagamento from '../../../../components/FluxosPagamento/FluxosPagamento'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import { TIPO_PROMOCAO_CRIACAO_ASSINATURA } from '../../../../components/CupomPromocao/constantsPromocao'
import { EVENTOS_GA, FLUXOS_PAGAMENTO, MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, ROUTE_BASEPATH, INFORMACAO_MODALIDADES } from '../../../../constants'
import { getInformacoesModalidadePorAssinatura } from '../../../../utils/helpers/helpersAssinatura'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { LABEL_BOTAO_SEGUNDA_ASSINATURA } from './constantsSegundaAssinatura'
import InlineLoader from '../../../../components/InlineLoader/InlineLoader'
import { navigate } from '@reach/router'
import { TIPOS_FLUXO_BRINDES } from '../../../../components/FluxosPagamento/constantsFluxosPagamento'
import { URLS_APP } from '../../../../config'
import { criarUsuarioLog, TIPOS_LOG_USUARIO } from '../../../../api/usuarioLog.servico'

const Titulo = styled.h1`
  margin: 25px 0 10px 0;
`

const SegundaAssinatura = ( { location } ) => {
  const visualizacaoInicialBreadcrumb = [ 'Plano', 'Entrega', 'Pagamento', 'Conclusão' ]
  const {
    dadosGlobaisAssociado,
    modalidadesDaAssinatura,
    modalidadeURL,
    setFluxoGA,
    verifyAtMaintenance,
  } = useGlobal()
  const {
    dadosRetornoRequisicao,
    loadingSegundaAssinatura,
    postSegundaAssinatura,
    sucessoSegundaAssinatura,
    setDescontoTotalSegundaAssinatura,
    setLoadingSegundaAssinatura,
  } = useSegundaAssinatura()
  const [ modalidadeEscolhaPlano, setModalidadeEscolhaPlano ] = useState()
  const [ descricaoModalidade, setDescricaoModalidade ] = useState()
  const [ dadosDescontoCombo, setDadosDescontoCombo ] = useState( {} )
  const [ modalidadeTitulo, setModalidadeTitulo ] = useState()
  const [ hasCuradoria, setHasCuradoria ] = useState( false )
  const [ hasIneditos, setHasIneditos ] = useState( false )
  const [ visualizacaoBreadcrumb, setVisualizacaoBreadcrumb ] = useState( visualizacaoInicialBreadcrumb )
  const [ brindesFluxo, setBrindesFluxo ] = useState( [] )

  useEffect( () => {
    setFluxoGA( EVENTOS_GA.SEGUNDA_ASSINATURA.FLUXO )
    criarUsuarioLog( TIPOS_LOG_USUARIO.INICIOU_CHECKOUT_ADA_SEGUNDA_ASSINATURA )
  }, [] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.modalidades ) {
      const modalidadeIncluidaPathname = location.pathname.split( '/' ).find( path => {
        const infoModalidadeIncluidaNoPathname = INFORMACAO_MODALIDADES.find( modalidade => modalidade.slug === path )
        return !isEmptyObject( infoModalidadeIncluidaNoPathname )
      } )
      const modalidadeParaAssociar = modalidadeIncluidaPathname === MODALIDADE_CURADORIA.slug ? MODALIDADE_INEDITOS.slug : MODALIDADE_CURADORIA.slug
      const infoModalidadeParaAssociar = getInformacoesModalidadePorAssinatura( modalidadeParaAssociar )

      const modalidadeParaDescricao = dadosGlobaisAssociado.modalidades.find( item => item.nome === infoModalidadeParaAssociar.visualizacao )

      setModalidadeEscolhaPlano( infoModalidadeParaAssociar.slug )
      setModalidadeTitulo( infoModalidadeParaAssociar.visualizacao )
      setDescricaoModalidade( modalidadeParaDescricao.resumo )
    }
  }, [ dadosGlobaisAssociado, location ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado && dadosGlobaisAssociado.assinaturas && modalidadesDaAssinatura ) {
      if ( modalidadesDaAssinatura.includes( MODALIDADE_CURADORIA.visualizacao ) ) {
        setHasCuradoria( true )
      }

      if ( modalidadesDaAssinatura.includes( MODALIDADE_INEDITOS.visualizacao ) ) {
        setHasIneditos( true )
      }
    }
  }, [ dadosGlobaisAssociado, modalidadesDaAssinatura ] )

  const fazerSegundaAssinatura = async dadosFluxo => {
    setLoadingSegundaAssinatura( true )
    const atMaintenance = await verifyAtMaintenance()
    if ( !isEmptyObject( dadosFluxo ) && !atMaintenance ) {
      await postSegundaAssinatura( dadosFluxo )
    } else {
      setLoadingSegundaAssinatura( true )
    }
  }

  const montarFluxoComBrindes = brindes => {
    if ( brindes.length > 1 ) {
      setBrindesFluxo( brindes )
      setVisualizacaoBreadcrumb( [ 'Plano', 'Entrega', 'Pagamento', 'Brinde', 'Conclusão' ] )
    } else {
      setBrindesFluxo( [] )
      setVisualizacaoBreadcrumb( visualizacaoInicialBreadcrumb )
    }
  }

  if ( hasIneditos && hasCuradoria ) {
    navigate( `${ROUTE_BASEPATH}${URLS_APP.BASE_PATH ? '/' : ''}${modalidadeURL}` )
    return null
  } else if ( hasIneditos || hasCuradoria ) {
    return (
      modalidadeTitulo && modalidadeURL ?
        <Fragment>
          <BreadcrumbGlobal
            exactPath="segunda-assinatura"
            nomeAlternativo="Segunda Assinatura"
            palavrasExcluidas={ /plano|entrega|pagamento|brindes|conclusao/u }
          />

          <Titulo>{ `Assinar a TAG ${modalidadeTitulo}` }</Titulo>

          <FluxosPagamentoProvider
            descontoCombo={ setDadosDescontoCombo }
            fluxoPagamentoAtual={ TIPOS_FLUXO_BRINDES[ FLUXOS_PAGAMENTO.SEGUNDA_ASSINATURA ] }
            modalidadeParaBrinde={ getInformacoesModalidadePorAssinatura( modalidadeTitulo ).id }
            montarFluxoComBrindes={ montarFluxoComBrindes }
          >
            <FluxosPagamento
              visualizacaoEtapas={ visualizacaoBreadcrumb }
            >
              <FluxosPagamento.Plano
                descricao={ descricaoModalidade }
                modalidadeSelecaoPlano={ modalidadeEscolhaPlano }
              />

              <FluxosPagamento.Entrega />

              <FluxosPagamento.Pagamento
                modalidadeSelecaoPlano={ modalidadeEscolhaPlano }
              />

              {
                brindesFluxo.length ?
                  <FluxosPagamento.Brindes
                    brindesFluxo={ brindesFluxo }
                  /> : []
              }

              <FluxosPagamento.Conclusao
                concluirFluxo={ dados => fazerSegundaAssinatura( dados ) }
                dadosDescontoCombo={ dadosDescontoCombo }
                dadosRetornoRequisicao={ dadosRetornoRequisicao }
                fluxo={ FLUXOS_PAGAMENTO.SEGUNDA_ASSINATURA }
                fluxoTemPromocao
                labelBotaoUltimaEtapa={ LABEL_BOTAO_SEGUNDA_ASSINATURA }
                loadingRequisicao={ loadingSegundaAssinatura }
                modalidadeSelecaoPlano={ modalidadeTitulo }
                respostaRequisicao={ sucessoSegundaAssinatura }
                setDescontoTotalSegundaAssinatura={ setDescontoTotalSegundaAssinatura }
                tipoAssinaturaPromocao={ TIPO_PROMOCAO_CRIACAO_ASSINATURA }
              />
            </FluxosPagamento>
          </FluxosPagamentoProvider>
        </Fragment> :
        <InlineLoader isCenter />
    )
  }

  return null
}

SegundaAssinatura.propTypes = {
  'location': object.isRequired
}

export default SegundaAssinatura
